// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Setup scroll event listeners on the issue element
document.addEventListener("DOMContentLoaded", () => {

    let lastFocused; 

    function setFocusIfUserIsFocusing(element) {
        if ((document.activeElement && document.activeElement !== document.body) || lastFocused) {
            element.focus();
            lastFocused = element;
        }
    }

    const handleKeydown = (e) => {
        if (!document.querySelector('.issue')) {
            return;
        }
        if (e.key === 'Tab') {
            if (document.activeElement && document.activeElement === document.body ) {
                e.preventDefault();
                const activeSection = document.querySelector('.active');
                const focusableElement = activeSection.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (focusableElement) {
                    focusableElement.focus();
                    lastFocused = focusableElement;
                }
            } else {
                if (e.shiftKey && e.key === 'Tab' && document.activeElement.classList.contains('controls')) {
                    const activeSection = document.querySelector('.active');
                    const focusableElement = activeSection.querySelector('button:not(.kg-audio-hide), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                    if (focusableElement) {
                        setFocusIfUserIsFocusing(focusableElement);
                    }
                } else {
                    setTimeout(() => {
                        if (document.activeElement && !document.activeElement.closest('.active')) {
                            const parent = document.activeElement.closest('article, section');
                            const focusableElement = parent.querySelector('button:not(.kg-audio-hide), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                            if (focusableElement) {
                                focusableElement.focus();
                                lastFocused = focusableElement;
                            }
                        }
                    }, 30)
                }
            }
        }
        const shWindowActive = document.querySelector('.sh-window').classList.contains('active');
        const activeSectionContainsScrollDiv = document.querySelector('.active .right:has(.scroll)');
        if (e.key === 'ArrowDown' && !shWindowActive && !activeSectionContainsScrollDiv) {
            e.preventDefault();
            const activeSection = document.querySelector('.active');
            const nextSection = activeSection.nextElementSibling;
            if (nextSection) {
                const focusableElement = nextSection.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (focusableElement) {
                    focusableElement.focus();
                    lastFocused = focusableElement;
                }
            }
        }
        if (e.key === 'ArrowUp' && !shWindowActive && !activeSectionContainsScrollDiv) {
            e.preventDefault();
            const activeSection = document.querySelector('.active');
            const previousSection = activeSection.previousElementSibling;
            if (previousSection) {
                const focusableElement = previousSection.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (focusableElement) {
                    focusableElement.focus();
                    lastFocused = focusableElement;
                }
            }
        }
    }

    window.addEventListener('keydown', handleKeydown);

    const support = document.querySelector('.page-support');
    if (support) {
        // Move the audio card to the div.left element
        const audioCard = document.querySelector('.kg-audio-card');
        if (audioCard) {
            const right = document.querySelector('article .left');
            right.appendChild(audioCard);
            audioCard.style.display = 'block';
        }

        const audioEl = support.querySelector('.kg-audio-card audio');
        const playButton = support.querySelector('.kg-audio-play-icon');
        const pauseButton = support.querySelector('.kg-audio-pause-icon');
        const currentTimeEl = support.querySelector('.kg-audio-current-time');
        const durationEl = support.querySelector('.kg-audio-time');
        const getReadableTime = (time) => {
            const minutes = Math.floor(time / 60);
            const seconds = Math.round(time % 60);
            if (isNaN(minutes) || isNaN(seconds)) {
                return '0:00';
            }
            return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
        }
        // Set the duration el 
        if (audioEl) {
            const duration = audioEl.duration;
            const readableDuration = getReadableTime(duration);
            durationEl.textContent = readableDuration;
        }
        audioEl.addEventListener('timeupdate', () => {
            const duration = audioEl.duration;
            const currentTime = audioEl.currentTime;
            const readableDuration = getReadableTime(duration);
            const readableCurrentTime = getReadableTime(currentTime);
            currentTimeEl.textContent = readableCurrentTime;
            durationEl.textContent = readableDuration;
        });
        playButton.addEventListener('click', () => {
            audioEl.play();
            playButton.classList.add('kg-audio-hide');
            pauseButton.classList.remove('kg-audio-hide');
        });
        pauseButton.addEventListener('click', () => {
            audioEl.pause();
            playButton.classList.remove('kg-audio-hide');
            pauseButton.classList.add('kg-audio-hide');
        });
        audioEl.addEventListener('ended', () => {
            playButton.classList.remove('kg-audio-hide');
            pauseButton.classList.add('kg-audio-hide');
        });

        const tiers = document.querySelectorAll('.tier');
        const nameEl = document.querySelector('.tier-name');
        const detailsEl = document.querySelector('.tier-details');
        for (const tier of tiers) {
            tier.addEventListener('mouseenter', (e) => {
                if (e.target.classList.contains('tier--donate')) {
                    detailsEl.classList.add('donate');
                    nameEl.classList.add('donate');
                } else {
                    detailsEl.classList.remove('donate');
                    nameEl.classList.remove('donate');
                }
                const monthlyPrice = tier.getAttribute('data-monthly-price');
                const yearlyPrice = tier.getAttribute('data-yearly-price');
                const name = tier.getAttribute('data-name');
                const benefits = tier.querySelector('ul');
                nameEl.textContent = name;
                detailsEl.querySelector('ul').innerHTML = benefits.innerHTML;
                detailsEl.querySelector('.monthly_price').textContent = monthlyPrice;
                detailsEl.querySelector('.yearly_price').textContent = yearlyPrice;
            });
            tier.addEventListener('click', (e) => {
                // Add an overlay to the page that says "Redirecting..."
                const overlay = document.createElement('div');
                overlay.classList.add('overlay');
                const overlayText = document.createElement('p');
                overlayText.textContent = 'Loading...';
                overlay.appendChild(overlayText);
                document.body.appendChild(overlay);
            });

        }
    }

    const passwordScreen = document.querySelector('.password-screen');
    if (passwordScreen) {
        // Check if the password is already saved in local storage
        const password = localStorage.getItem('password');
        if (password === 'signalpreview') {
            passwordScreen.style.display = 'none';
            document.body.style.overflow = 'auto';
        } else {
            document.body.style.overflow = 'hidden';
            const passwordForm = passwordScreen.querySelector('form');
            const passwordInput = passwordForm.querySelector('input');
            const passwordSubmit = passwordForm.querySelector('button');
            passwordForm.addEventListener('submit', (e) => {
                e.preventDefault();
                if (passwordInput.value === 'signalpreview') {
                    passwordScreen.style.display = 'none';
                    document.body.style.overflow = 'auto';
                    // Save the password to local storage
                    localStorage.setItem('password', passwordInput.value);
                } else {
                    passwordInput.value = '';
                    passwordInput.focus();
                }
            });
        }
    }

    const teaser = document.querySelector('.teaser');
    if (teaser) {
        const audioEl = teaser.querySelector('.kg-audio-card audio');
        const playButton = teaser.querySelector('.kg-audio-play-icon');
        const pauseButton = teaser.querySelector('.kg-audio-pause-icon');
        const currentTimeEl = teaser.querySelector('.kg-audio-current-time');
        const durationEl = teaser.querySelector('.kg-audio-time');
        const getReadableTime = (time) => {
            const minutes = Math.floor(time / 60);
            const seconds = Math.round(time % 60);
            if (isNaN(minutes) || isNaN(seconds)) {
                return '0:00';
            }
            return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
        }
        // Set the duration el 
        if (audioEl) {
            const duration = audioEl.duration;
            const readableDuration = getReadableTime(duration);
            durationEl.textContent = readableDuration;
        }
        audioEl.addEventListener('timeupdate', () => {
            const duration = audioEl.duration;
            const currentTime = audioEl.currentTime;
            const readableDuration = getReadableTime(duration);
            const readableCurrentTime = getReadableTime(currentTime);
            currentTimeEl.textContent = readableCurrentTime;
            durationEl.textContent = readableDuration;
        });
        playButton.addEventListener('click', () => {
            audioEl.play();
            playButton.classList.add('kg-audio-hide');
            pauseButton.classList.remove('kg-audio-hide');
        });
        pauseButton.addEventListener('click', () => {
            audioEl.pause();
            playButton.classList.remove('kg-audio-hide');
            pauseButton.classList.add('kg-audio-hide');
        });
        audioEl.addEventListener('ended', () => {
            playButton.classList.remove('kg-audio-hide');
            pauseButton.classList.add('kg-audio-hide');
        });
    }

    const audioEl = document.querySelector('.sh-player audio');

    const playerControlsEl = audioEl?.closest('.sh-player').querySelector('.controls');
    const playerTitleEl = audioEl?.closest('.sh-player').querySelector('.title');
    const windowEl = document.querySelector('.sh-window');

    if (audioEl) {
        
        const playBarEl = audioEl.closest('.sh-player').querySelector('.play-bar');
        // Setup click listenever for the play bar el

        const handlePlayBarClick = (e) => {
            const rect = playBarEl.getBoundingClientRect();
            const offsetX = e.clientX - rect.left;
            const percent = offsetX / playBarEl.offsetWidth;
            const duration = audioEl.duration;
            audioEl.currentTime = percent * duration;
            const progressEl = audioEl.closest('.sh-player').querySelector('.progress');
            const readableDuration = getReadableTime(duration);
            const readableCurrentTime = getReadableTime(audioEl.currentTime);
            progressEl.textContent = `${readableCurrentTime} / ${readableDuration}`;
            const playbarProgressEl = audioEl.closest('.sh-player').querySelector('.play-bar__progress');
            playbarProgressEl.style.width = `${percent * 100}%`;
        }

        playBarEl.addEventListener('click', handlePlayBarClick);

        function handleKeydown(e) {
            if (e.key === 'ArrowRight') {
                e.preventDefault();
                audioEl.currentTime += 10;
            }
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                audioEl.currentTime -= 10;
            }
        }
        
        audioEl.addEventListener('play', () => {
            // Setup keyboard listeners to fast forward on arrow right, and rewind on arrow left
            window.addEventListener('keydown', handleKeydown);
        });

        audioEl.addEventListener('ended', () => {
            const playing = document.querySelectorAll('.kg-audio-card:has(.kg-audio-play-icon.kg-audio-hide) .kg-audio-player');
            for (const el of playing) {
                const playButton = el.querySelector('button.kg-audio-play-icon');
                const pauseButton = el.querySelector('button.kg-audio-pause-icon');
                if (playButton.classList.contains('kg-audio-hide')) {
                    playButton.classList.remove('kg-audio-hide');
                }
                if (!pauseButton.classList.contains('kg-audio-hide')) {
                    pauseButton.classList.add('kg-audio-hide');
                }
            }
        });
        const getReadableTime = (time) => {
            const minutes = Math.floor(time / 60);
            const seconds = Math.round(time % 60);
            if (isNaN(minutes) || isNaN(seconds)) {
                return '0:00';
            }
            return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
        }
        audioEl.addEventListener('timeupdate', () => {
            const duration = audioEl.duration;
            const currentTime = audioEl.currentTime;
            const readableDuration = getReadableTime(duration);
            const readableCurrentTime = getReadableTime(currentTime);
            const progressEl = audioEl.closest('.sh-player').querySelector('.progress');
            progressEl.textContent = `${readableCurrentTime} / ${readableDuration}`;
            const percent = (currentTime / duration) * 100;
            const playbarProgressEl = audioEl.closest('.sh-player').querySelector('.play-bar__progress');
            playbarProgressEl.style.width = `${percent}%`;
        });
    }

    // Setup a global click listener to handle audio player related interactions
    window.addEventListener("click", (e) => {
        const target = e.target;

        if (
            target.closest('nav .left') && window.innerWidth < 800
        ) {
            e.preventDefault();
            if (target.closest('nav').classList.contains('mobile-open')) {
                target.closest('nav').classList.remove('mobile-open');
            } else {
                target.closest('nav').classList.add('mobile-open');
            }
        }

        let inlinePlayer = target.closest('.issue .kg-audio-player');
        if (inlinePlayer) {
            const playButton = inlinePlayer.querySelector('button.kg-audio-play-icon');
            if (playButton === target || playButton.contains(target)) {
                handleAudioPlay(inlinePlayer);
            }
            const pauseButton = inlinePlayer.querySelector('button.kg-audio-pause-icon');
            if (pauseButton === target || pauseButton.contains(target)) {
                handleAudioPause(inlinePlayer);
            }
        }
        if (target === playerControlsEl || playerControlsEl.contains(target)) {
            const slug = playerTitleEl.getAttribute('href').replace('#', '');
            if (slug) {
                inlinePlayer = document.querySelector(`[id="${slug}"] .kg-audio-player`);
                if (playerControlsEl.textContent === 'Play') {
                    handleAudioPlay(inlinePlayer);
                } else {
                    handleAudioPause(inlinePlayer);
                }
            }
        }
        if (target.getAttribute('data-window-link')) {
            const link = target.getAttribute('data-window-link');
            let slug;
            let title; 
            if (target.closest('article, section')) {
                slug = target.closest('article, section').getAttribute('id');
            }
            if (target.closest('.sh-player')) {
                slug = target.closest('.sh-player').querySelector('.title').getAttribute('href').replace('#', '');
            }
            if (slug) {
                const titleEl = document.querySelector(`#${slug} h1`);
                if (titleEl) {
                    title = titleEl.textContent;
                }

            }

            function parseCSV(csvText) {
                const lines = csvText.trim().split(/\r?\n/);
                const headers = parseCSVLine(lines[0]);
              
                return lines.slice(1).map(line => {
                  const values = parseCSVLine(line);
                  const entry = {};
                  headers.forEach((header, i) => {
                    entry[header] = values[i] ?? '';
                  });
                  return entry;
                });
              }
              
              function parseCSVLine(line) {
                const result = [];
                let current = '';
                let inQuotes = false;
                for (let i = 0; i < line.length; i++) {
                  const char = line[i];
                  if (inQuotes) {
                    if (char === '"') {
                      if (line[i + 1] === '"') {
                        current += '"';
                        i++;
                      } else {
                        inQuotes = false;
                      }
                    } else {
                      current += char;
                    }
                  } else {
                    if (char === '"') {
                      inQuotes = true;
                    } else if (char === ',') {
                      result.push(current.trim());
                      current = '';
                    } else {
                      current += char;
                    }
                  }
                }
                result.push(current.trim());
                return result;
              }

            if (windowEl) {
                if (!windowEl.classList.contains('active')) {
                    windowEl.classList.add('active');
                }
                const closeButton = windowEl.querySelector('.close');
                // Focus the close button
                setFocusIfUserIsFocusing(closeButton);
                const windowHeaderEl = windowEl.querySelector('.sh-window__header p');
                const windowBodyEl = windowEl.querySelector('.sh-window__body');
                windowBodyEl.innerHTML = '';
                switch(link) {
                    case 'notes': {
                        windowHeaderEl.textContent = `${title} - Notes`;
                        const notesNodes = document.querySelectorAll(`#${slug} #notes ~ *`);
                        for (const node of notesNodes) {
                            windowBodyEl.appendChild(node.cloneNode(true));
                        }
                        break;
                    }
                    case 'transcript': {
                        windowHeaderEl.textContent = `${title} - Transcript`;
                        const pdfUrl = document.querySelector(`#${slug} [href$=".pdf"]`)?.getAttribute('href');
                        if (pdfUrl) {
                            const pdfIframe = document.createElement('iframe');
                            pdfIframe.src = pdfUrl;
                            pdfIframe.width = '100%';
                            pdfIframe.height = '100%';
                            pdfIframe.frameBorder = '0';
                            windowBodyEl.appendChild(pdfIframe);
                        }
                        const csvUrl = document.querySelector(`#${slug} [href$=".csv"]`)?.getAttribute('href');
                        if (csvUrl) {
                            // Fetch and parse the CSV
                            fetch(csvUrl)
                                .then(response => response.text())
                                .then(text => {
                                    const parsed = parseCSV(text);
                                    const transcriptEl = document.createElement('div');
                                    transcriptEl.classList.add('transcript');
                                    for (const obj of parsed) {
                                        const p = document.createElement('p');
                                        if (obj['Type']) {
                                            const lowercaseType = obj['Type'].toLowerCase();
                                            p.classList.add(lowercaseType);
                                        }
                                        if (obj['Subject']) {
                                            const span = document.createElement('span');
                                            span.classList.add('subject');
                                            span.textContent = obj['Subject'];
                                            p.appendChild(span);
                                        }
                                        if (obj['Content']) {
                                            const textNode = document.createTextNode(obj['Content']);
                                            p.appendChild(textNode);
                                        }
                                        // Add a span with class 'subject', and the content of the 'Subject' property
                                        transcriptEl.appendChild(p);
                                    }
                                    windowBodyEl.appendChild(transcriptEl);
                                });
                        }
                        break;
                    }
                    case 'share': {
                        windowHeaderEl.textContent = `${title} - Share`;
                        const shareDiv = document.createElement('div');
                        shareDiv.classList.add('share');
                        const shareText = window.origin + window.location.pathname + '#' + slug;
                        const shareEl = document.createElement('p');
                        shareEl.textContent = shareText;
                        shareDiv.appendChild(shareEl);
                        const copyButton = document.createElement('button');
                        copyButton.textContent = 'Copy URL';
                        copyButton.classList.add('copy');
                        copyButton.addEventListener('click', () => {
                            navigator.clipboard.writeText(shareText);
                            // Also select the text
                            const range = document.createRange();
                            range.selectNode(shareEl);
                            window.getSelection().removeAllRanges();
                            window.getSelection().addRange(range);
                            // Add a success message to the button
                            copyButton.textContent = 'Copied!';
                        });
                        shareDiv.appendChild(copyButton);
                        windowBodyEl.appendChild(shareDiv);
                        break;
                    }
                }
            }
        }
        if (target.classList.contains('close') && target.closest('.sh-window')) {
            const headingContent = target.closest('.sh-window').querySelector('.sh-window__header p');
            let mode;
            switch (true) {
                case headingContent.textContent.includes('Notes'): {
                    mode = 'notes';
                    break;
                }
                case headingContent.textContent.includes('Transcript'): {
                    mode = 'transcript';
                    break;
                }
                case headingContent.textContent.includes('Share'): {
                    mode = 'share';
                    break;
                }
            }

            // Get the corresponding link in the .active section
            const link = document.querySelector(`.active [data-window-link="${mode}"]`);

            if (link) {
                setFocusIfUserIsFocusing(link);
            }

            windowEl.classList.remove('active');
        }
    });

    const handleAudioPlay = (player) => {

        storiesPlayed = storiesPlayed + 1;
        const emailSignUpLocalStorage = localStorage.getItem('emailSignup');
        if (storiesPlayed === 2 && !emailSignUpLocalStorage) {
            const emailSignupEl = document.querySelector('.email-signup');
            if (emailSignupEl) {
                // Setup keydown listenver to close on escape
                window.addEventListener('keydown', (e) => {
                    if (e.key === 'Escape') {
                        emailSignupEl.classList.remove('active');
                        // Get the first focusable element in the active section
                        const activeSection = document.querySelector('article.active, section.active');
                        const focusableElement = activeSection.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                        if (focusableElement) {
                            focusableElement.focus();
                        }
                    }
                });
                emailSignupEl.classList.add('active');
            }
        }

        // Pause all other audio players
        const playing = document.querySelectorAll('.kg-audio-card:has(.kg-audio-play-icon.kg-audio-hide) .kg-audio-player');
        for (const el of playing) {
            if (el !== player) {
                const playButton = el.querySelector('button.kg-audio-play-icon');
                const pauseButton = el.querySelector('button.kg-audio-pause-icon');
                if (playButton.classList.contains('kg-audio-hide')) {
                    playButton.classList.remove('kg-audio-hide');
                }
                if (!pauseButton.classList.contains('kg-audio-hide')) {
                    pauseButton.classList.add('kg-audio-hide');
                }
            }
        }

        const playButton = player.querySelector('button.kg-audio-play-icon');
        playButton.classList.toggle('kg-audio-hide');
        const pauseButton = player.querySelector('button.kg-audio-pause-icon');
        pauseButton.classList.toggle('kg-audio-hide');

        // Set focus to the pause button
        if (pauseButton) {
            setFocusIfUserIsFocusing(pauseButton);
        }

        const src = player.parentNode.querySelector('audio').getAttribute('src');
        const slug = player.closest('[data-slug]').getAttribute('data-slug');

        if (playerControlsEl) {
            playerControlsEl.innerHTML = 'Pause';
        }

        if (!hasNotes(slug)) {
            const notesLink = document.querySelector(`.sh-player [data-window-link="notes"]`);
            if (notesLink) {
                notesLink.style.display = 'none';
            }
        } else {
            const notesLink = document.querySelector(`.sh-player [data-window-link="notes"]`);
            if (notesLink) {
                notesLink.style.display = 'block';
            }
        }

        if (!hasTranscript(slug)) {
            const transcriptLink = document.querySelector(`.sh-player [data-window-link="transcript"]`);
            if (transcriptLink) {
                transcriptLink.style.display = 'none';
            }
        } else {
            const transcriptLink = document.querySelector(`.sh-player [data-window-link="transcript"]`);
            if (transcriptLink) {
                transcriptLink.style.display = 'block';
            }
        }

        if (audioEl) {
            if (audioEl.src === src && playerTitleEl.href.endsWith(slug)) {
                audioEl.play();
            } else {
                if (!audioEl.parentNode.classList.contains('active')) {
                    audioEl.parentNode.classList.add('active');
                }
                if (playerTitleEl) {
                    let content;
                    const titleEl = player.parentNode.querySelector('.kg-audio-title');
                    if (titleEl) {
                        content = titleEl.textContent;
                    }
                    const bylineEl = player.closest('article, section').querySelector('.byline');
                    if (bylineEl) {
                        content = content + ' - ' + bylineEl.textContent;
                    }
                    playerTitleEl.textContent = content;
                    const id = player.closest('article, section').getAttribute('id');
                    if (id) {
                        playerTitleEl.setAttribute('href', '#' + id);
                    }
                }
                audioEl.pause();
                audioEl.currentTime = 0;
                audioEl.setAttribute('src', src);
                audioEl.load();
                audioEl.play();
            }
        }
    }

    const handleAudioPause = (player) => {
        if (playerControlsEl) {
            playerControlsEl.innerHTML = 'Play';
        }

        const playButton = player.querySelector('button.kg-audio-play-icon');
        playButton.classList.toggle('kg-audio-hide');
        const pauseButton = player.querySelector('button.kg-audio-pause-icon');
        pauseButton.classList.toggle('kg-audio-hide');

        // Set focus to the play button
        if (playButton) {
            setFocusIfUserIsFocusing(playButton);
        }

        if (audioEl) {
            audioEl.pause();
        }
    }

    const audioDurationEls = document.querySelectorAll(".kg-audio-duration");
    for (const el of audioDurationEls) {
        const timeEl = el.closest(".kg-audio-time");
        const duration = Number(el.textContent);
        timeEl.setAttribute("data-duration", duration);
        const minutes = Math.floor(duration / 60);
        const seconds = Math.round(duration % 60);
        timeEl.textContent = `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    }

    const hasNotes = (slug) => {
        const notesNodes = document.querySelectorAll(`#${slug} #notes ~ *`);
        return notesNodes.length > 0;
    }

    const hasTranscript = (slug) => {
        const csvUrl = document.querySelector(`#${slug} [href$=".csv"]`)?.getAttribute('href');
        const pdfUrl = document.querySelector(`#${slug} [href$=".pdf"]`)?.getAttribute('href');
        return pdfUrl || csvUrl ? true : false;
    }

    let storiesPlayed = 0;

    const issue = document.querySelector(".issue");
    if (issue) {

        const emailSignupEl = document.querySelector('.email-signup');
        emailSignupEl.addEventListener("click", (e) => {
            if (e.target === emailSignupEl) {
                // Store a variable in local storage to prevent the email signup from showing again
                localStorage.setItem('emailSignup', 'true');
                emailSignupEl.classList.remove('active');
            }
        });

        const focusableEls = issue.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        for (const el of focusableEls) {
            el.addEventListener('focus', () => {
                // Wait 200ms
                    // Check if the element is visible (has a closest .active)
                    const active = el.closest('.active');
                    if (active) {
                        return;
                    }
                    // If not, get the slug of the closest article or section
                    const slug = el.closest('article, section').getAttribute('id');
                    // Update the hash in the URL and scroll to the element
                    if (slug) {
                        const el = document.querySelector(`#${slug}`);
                        if (el) {
                            el.scrollIntoView();
                        }
                    }
            });
        }

        const slugInUrl = window.location.hash.replace('#', '');
        if (slugInUrl) {
            // Wait 20ms, then scroll to the element
            setTimeout(() => {
                const el = document.querySelector(`#${slugInUrl}`);
                if (el) {
                    el.scrollIntoView();
                }
            }, 200);
        }



        const stories = document.querySelectorAll('.story, .letter');
        for (const story of stories) {
            // If it does not have notes, then remove the notes link from the details
            const slug = story.getAttribute('data-slug');
            const notesLink = story.querySelector('[data-window-link="notes"]');
            if (notesLink && !hasNotes(slug)) {
                notesLink.remove();
            }
            // If it does not have a transcript, then remove the transcript link from the details
            const transcriptLink = story.querySelector('[data-window-link="transcript"]');
            if (transcriptLink && !hasTranscript(slug)) {
                transcriptLink.remove();
            }
        }

        const audioCards = document.querySelectorAll('.kg-audio-card');
        for (const card of audioCards) {
            // If the .kg-audio-title element contains the text "Coming soon" add a class to the parent element
            const titleEl = card.querySelector('.kg-audio-title');
            if (titleEl && titleEl.textContent.toLowerCase().includes('coming soon')) {
                // Runtime el in contents card
                const closestSlug = card.closest("[data-slug]")?.getAttribute("data-slug");
                if (closestSlug) {
                    const contentsPostEl = document.querySelector(`.contents [data-slug="${closestSlug}"]`);
                    const runtimeEl = contentsPostEl?.querySelector('.details .runtime');
                    if (runtimeEl) {
                        runtimeEl.style.display = 'none';
                    }
                }
                card.classList.add('coming-soon');
            }
        }

        let isScrolling = false;
        let scrollStartSection = null;

        const getScrollSnapPoints = (container) => {
            const computedStyle = window.getComputedStyle(container);
            const snapType = computedStyle.getPropertyValue('scroll-snap-type');
            const snapAlign = computedStyle.getPropertyValue('scroll-snap-align');
        
            if (!snapType.includes('mandatory')) {
                return [];
            }
        
            const snapPoints = [];
            const children = Array.from(container.children);
            children.forEach(child => {
                const childStyle = window.getComputedStyle(child.querySelector('.left'));
                const snapAlignChild = childStyle.getPropertyValue('scroll-snap-align');
                if (snapAlignChild.includes('start')) {
                    snapPoints.push(child.offsetTop);
                }
                if (snapAlignChild.includes('end')) {
                    snapPoints.push(child.offsetTop + child.offsetHeight - container.offsetHeight);
                }
                if (snapAlignChild.includes('center')) {
                    snapPoints.push(child.offsetTop + (child.offsetHeight - container.offsetHeight) / 2);
                }
            });
        
            return snapPoints;
        };

        const snapPoints = getScrollSnapPoints(issue);

        // Copy run times to the contents
        const audioTimes = document.querySelectorAll(".kg-audio-time");
        for (const time of audioTimes) {
            const closestSlug = time.closest("[data-slug]")?.getAttribute("data-slug");
            if (closestSlug) {
                const runtimeEl = document.querySelector(`.contents [data-slug="${closestSlug}"] .details .runtime`);
                if (runtimeEl) {
                    runtimeEl.textContent = time.textContent;
                }
            }
        }

        // Move .story .byline to just before the .kg-audio-card
        const bylines = document.querySelectorAll(".story .byline");
        for (const byline of bylines) {
            const audioCard = byline.closest(".story").querySelector(".kg-audio-card");
            if (audioCard) {
                audioCard.parentNode.insertBefore(byline, audioCard);
            } else {
                // Move to the end of the story
                const story = byline.closest(".story");
                story.appendChild(byline);
            }
        }

        let lastScroll = 0;
        let lastDirection = 'down';
        let ticking = false;
        function onScroll () {
            lastDirection = issue.scrollTop > lastScroll ? 'down' : 'up';
            const delta = Math.abs(issue.scrollTop - lastScroll);
            lastScroll = issue.scrollTop;
            if (!ticking) {
                window.requestAnimationFrame(function() {
                    handleScroll(lastScroll, lastDirection, delta);
                    ticking = false;
                });
                ticking = true;
            }
        }

        const leftEls = issue.querySelectorAll('div.left');
        const parentsArr = [];

        const getParent = (el) => {
            const section = el.closest('section');
            if (section) {
                return section;
            }
            const article = el.closest('article');
            if (article) {
                return article;
            }
            return null;
        }

        // Loop through each el and set the top and bottom based on its bounding client rect
        for (const el of leftEls) {
            const parent = getParent(el);
            if (!parent) {
                continue;
            }
            const rect = el.getBoundingClientRect();
            parentsArr.push({
                parent,
                top: rect.top,
                bottom: rect.bottom
            });
        }

        let lastParent = null;        
        let hasInit = false;

        const handleScrollStart = () => {
            isScrolling = true;
            scrollStartSection = lastParent;
        }

        const handleScroll = function(scroll, direction, delta) {
            if (!isScrolling) {
                handleScrollStart();
            }
            debouncedHandleScrollEnd();
            if (!issue.classList.contains('scrolling') && delta && delta < 20) {
                issue.classList.add('scrolling');
            }
            // Determine which parent is currently in view
            let currentParent = null;
            const margin = 0.5;
            for (const parent of parentsArr) {
                const top = parent.top - issue.clientHeight * margin;
                const bottom = parent.bottom - issue.clientHeight * margin;
                if (scroll >= top && scroll <= bottom) {
                    currentParent = parent.parent;
                    break;
                }
            }
            if (currentParent === lastParent) {
                return;
            }
            handleParentUpdate(currentParent, !hasInit);
            hasInit = true;
        }

        const handleParentUpdate = (parent, isFirst) => {
            const duration = isFirst ? 0 : 0.2;
            if (parent === lastParent || !parent) {
                return;
            }
            if (lastParent) {
                const right = lastParent.querySelector('div.right');
                right.style.animation = lastDirection === 'up' ? `fadeOutDown ${duration}s forwards` : `fadeOutUp ${duration}s forwards`;
                lastParent.classList.remove('active');
            }
            const right = parent.querySelector('div.right');
            right.style.animation =  lastDirection === 'up' ? `fadeInDown ${duration}s forwards ${duration}s` : `fadeInUp ${duration}s forwards ${duration}s`;
            parent.classList.add('active');
            const parentScrollContainer = parent.querySelector('div.right:has(.scroll');
            if (parentScrollContainer) {
                parentScrollContainer.scrollTop = 0;
            }
            const tag = parent.getAttribute('data-tag');
            const slug = parent.getAttribute('data-slug');
            // Update the hash in the URL without scrolling the page to the element
            if (slug) {
                history.replaceState(null, null, '#' + slug);
            }
            const navEl = document.querySelector('.nav > li:first-child');
            if (navEl) {
                navEl.innerText = tag;
                if (!navEl.classList.contains('nav-current')) {
                    navEl.classList.add('nav-current');
                }
            }
            lastParent = parent;

            const focusableElement = parent.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (focusableElement) {
                setFocusIfUserIsFocusing(focusableElement);
            }
        };

        // Function to check if the current scroll position is at a snap point
        const isAtSnapPoint = (scrollPos, snapPoints) => {
            return snapPoints.some(point => Math.abs(scrollPos - point) < 5); // Allow a small margin of error
        };

        const handleScrollEnd = (e) => {
            isScrolling = false;    
            const scrollPos = issue.scrollTop;

            if (scrollStartSection && scrollStartSection !== lastParent) {
                const stickerEl = document.querySelector('.sticker');
                if (stickerEl) {
                    stickerEl.remove();
                }
            }

            if (isAtSnapPoint(scrollPos, snapPoints)) {
                if (issue.classList.contains('scrolling')) {
                    issue.classList.remove('scrolling');
                }
            }
        }

        const destroyDesktopIssue = () => {
            issue.removeEventListener('scroll', onScroll);
        }

        // Debounce function
        function debounce(func, wait) {
            let timeout;
            return function(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func.apply(this, args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        // Debounced version of handleScrollEnd
        const debouncedHandleScrollEnd = debounce(handleScrollEnd, 200);

        const initDesktopIssue = () => {
            issue.addEventListener('scroll', onScroll);

            // Initial setup
            handleScroll(issue.scrollTop, lastDirection);
        }

        // Add resize event listener to handle setup/destroy of desktop issue
        window.addEventListener('resize', () => {
            if (window.innerWidth > 800) {
                initDesktopIssue();
            } else {
                destroyDesktopIssue();
            }
        });

        // Setup desktop issue if window width is greater than 760
        if (window.innerWidth > 800) {
            initDesktopIssue();
        }

    }

});